export const ADMIN_BASE_PATH = "/app/admin";

export const ADMIN_PATHS = {
  overview: "/app/admin/dashboard",
  users: "/app/admin/users",
  ops: "/app/admin/ops",
  trivia: "/app/admin/trivia",
  community: "/app/admin/community",
  social: "/app/admin/social",
};

export const FAN_ADMIN_NAV_ITEM = {
  id: "admin",
  text: "Admin",
  path: ADMIN_PATHS.overview,
};

export const ADMIN_NAV_GROUPS = [
  {
    id: "monitor",
    label: "Monitor",
    items: [
      { id: "adminOverview", text: "Overview", path: ADMIN_PATHS.overview },
      { id: "adminOps", text: "Ops", path: ADMIN_PATHS.ops },
    ],
  },
  {
    id: "operate",
    label: "Operate",
    items: [
      { id: "adminUsers", text: "Users", path: ADMIN_PATHS.users },
      { id: "adminTrivia", text: "Trivia", path: ADMIN_PATHS.trivia },
      { id: "adminCommunity", text: "Community", path: ADMIN_PATHS.community },
      { id: "adminSocial", text: "Social", path: ADMIN_PATHS.social },
    ],
  },
];
